import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/browse.svg'
import _imports_1 from '@/assets/browse-off.svg'


const _withScopeId = n => (_pushScopeId("data-v-47844bc5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mask" }
const _hoisted_2 = ["title"]
const _hoisted_3 = ["title"]

import { computed } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  text: String,
  dataIndex: [String, Array],
  maskContact: Object
},
  emits: ['show', 'hide'],
  setup(__props, { emit: __emit }) {

const props = __props
const maskKey = computed(() => {
  if (Array.isArray(props.dataIndex)) {
    return props.dataIndex[props.dataIndex.length - 1]
  }
  return props.dataIndex
})
const emit = __emit
const showMessage = () => {
  emit('show')
}
const hideMessage = () => {
  emit('hide')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.maskContact && __props.maskContact[maskKey.value] && __props.maskContact.hideMask)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("p", {
            title: __props.maskContact[maskKey.value]
          }, _toDisplayString(__props.maskContact[maskKey.value] || '--'), 9, _hoisted_2),
          (__props.text)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _imports_0,
                class: "mask-eye",
                onClick: hideMessage
              }))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("p", { title: __props.text }, _toDisplayString(__props.text || '--'), 9, _hoisted_3),
          (__props.text)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _imports_1,
                class: "mask-eye",
                onClick: showMessage
              }))
            : _createCommentVNode("", true)
        ], 64))
  ]))
}
}

})